import { IRaffle } from "react-ui-components/components/models/IRaffle"
import { isGoalRaffle } from "react-ui-components/components/raffle/raffleGoalUtils"

// Kept in its own dependency-free module so it can be unit tested without pulling in
// RaffleContext.tsx's Firebase/location/translation providers.

// Filtered client-side rather than via a Firestore `where("visibleFrom", "<=", now)` clause:
// Firestore excludes documents that don't have the field at all from inequality queries,
// which would have hidden every raffle created before this field existed. See Trello #139.
export const hasReachedVisibilityStart = (raffle: IRaffle, now: number = Date.now()) => {
  if (!raffle.visibleFrom) {
    return true
  }

  return new Date(raffle.visibleFrom).getTime() <= now
}

export const isVisibleRaffle = (raffle: IRaffle, now: number = Date.now()) => {
  if (!hasReachedVisibilityStart(raffle, now)) {
    return false
  }

  if (isGoalRaffle(raffle)) {
    return true
  }

  if (!raffle.raffleDate) {
    return false
  }

  return new Date(raffle.raffleDate).getTime() >= now
}

// A raffle "ends" either because an admin disabled it outright, or because its drawing date has
// passed. Goal raffles have no drawing date, so (like isVisibleRaffle above) they only end via
// `disabled`. Used to stop showing a user's tickets for a raffle that has already ended, even
// when the ticket document's own `expirationDate` (set at purchase/sale time) hasn't caught up.
export const hasRaffleExpired = (
  raffle: Pick<IRaffle, "disabled" | "raffleDate" | "raffleMode" | "type" | "goalSettings">,
  now: number = Date.now(),
) => {
  if (raffle.disabled) {
    return true
  }

  if (isGoalRaffle(raffle)) {
    return false
  }

  if (!raffle.raffleDate) {
    return false
  }

  return new Date(raffle.raffleDate).getTime() < now
}
